var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"navigation"},[_c('li',[_c('a',{staticClass:"active",attrs:{"href":"#home"}},[_vm._v("Forside")])]),_c('li',[_c('a',{attrs:{"href":"https://isdragen.dk/tournament/"}},[_vm._v("Tournament")])]),_c('li',[_c('a',{attrs:{"href":"https://isdragen.dk/poll/index.php"}},[_vm._v("Afstemning")])])])
}]

export { render, staticRenderFns }